module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [_c('popup', {
    attrs: {
      "button-style": "primary",
      "heading": "New Contact",
      "show-text": _vm.showText,
      "button-text": "Contact",
      "center-button": true,
      "button-size": _vm.buttonSize,
      "disable-button": !_vm.isManager(),
      "button-icon": "fa fa-user",
      "before-save": _vm.validate
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('add-contact-details', {
    ref: "cd",
    attrs: {
      "name": "cd",
      "row-data": _vm.contactData,
      "org-id": _vm.org_id,
      "editMode": true,
      "adding": true,
      "hide-panel": true,
      "table-ref": _vm.tableRef
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f76aec2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/ContactAction.vue
// module id = 1742
// module chunks = 0